import { render, staticRenderFns } from "./TaskDueNotifications.vue?vue&type=template&id=10bcff2b&scoped=true"
import script from "./TaskDueNotifications.vue?vue&type=script&lang=js"
export * from "./TaskDueNotifications.vue?vue&type=script&lang=js"
import style0 from "./TaskDueNotifications.vue?vue&type=style&index=0&id=10bcff2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bcff2b",
  null
  
)

export default component.exports